import React from 'react';
import { Content, Loader, Table } from 'rsuite';
// @ts-ignore
import { useListaProdutosCompetitividadeAbaixo } from '../../../hooks/useListaProdutosCompetitividadeAbaixo.tsx';
import CurrencyFormat from 'react-currency-format';
import { HoverTooltip } from '../../../../../components/HoverTooltip';
const { Column, HeaderCell, Cell } = Table;

type RowData = {
  productId: string;
  description: string;
  storeName: string;
  avg_average_competitivity_retail: string;
  count: number;
};

const columns = [
  {
    align: 'left',
    headerCell: 'Produto',
    dataKey: 'productId',
  },
  {
    align: 'left',
    headerCell: 'Descrição',
    dataKey: 'description',
    flexGrow: 2,
  },
  {
    align: 'left',
    headerCell: 'Loja',
    dataKey: 'storeName',
    flexGrow: 2,
  },
  {
    align: 'left',
    headerCell: 'Competitividade',
    dataKey: 'avg_average_competitivity_retail',
    width: 80,
  },
  {
    align: 'right',
    headerCell: 'Itens',
    dataKey: 'count',
  },
  // @ts-ignore
] as Column<RowData>[];

export const ListaProdutosCompetitividadeAbaixo: React.FC = () => {
  const { data, isLoading } = useListaProdutosCompetitividadeAbaixo();

  if (isLoading)
    return (
      <Content className="componente-tabela-loading">
        <Loader center />
      </Content>
    );

  if (!data || !data.length)
    return (
      <Content className="componente-tabela">
        <h2>Corte outliers: produtos com competitividade abaixo de 50%</h2>
        <div className="sem-dados">
          <h3>Sem dados para essa análise</h3>
          <p>Revise os filtros e tente novamente</p>
        </div>
      </Content>
    );

  return (
    <Content className="componente-tabela">
      <h2>Corte outliers: produtos com competitividade abaixo de 50%</h2>
      <div className="table-container">
        <Table data={data} height={384} rowHeight={32}>
          {columns.map((column, index) => (
            <Column key={index} {...column}>
              <HeaderCell className="header-tabela">
                {column.dataKey === 'avg_average_competitivity_retail' ? (
                  <HoverTooltip placement="bottom" text={column.headerCell} />
                ) : (
                  <span>{column.headerCell}</span>
                )}
              </HeaderCell>
              {column.dataKey === 'avg_average_competitivity_retail' ? (
                <Cell dataKey={column.dataKey}>
                  {(rowData: RowData) =>
                    rowData.avg_average_competitivity_retail ? (
                      <div className="linha-tabela">
                        <CurrencyFormat
                          className="currency"
                          fixedDecimalScale
                          decimalScale={2}
                          value={rowData.avg_average_competitivity_retail || '--'}
                          displayType="text"
                          suffix="%"
                          decimalSeparator=","
                          thousandSeparator="."
                        />
                      </div>
                    ) : (
                      '--'
                    )
                  }
                </Cell>
              ) : (
                <Cell dataKey={column.dataKey}>{(rowData: RowData) => <div className="linha-tabela">{rowData[column.dataKey] || '--'}</div>}</Cell>
              )}
            </Column>
          ))}
        </Table>
      </div>
    </Content>
  );
};
